(() => {
 'use strict';
 const root = window.Shopify?.routes?.root || '/';
 const initSpecifications = scope => scope.querySelectorAll('[data-product-section]').forEach(section => {
  const panel = section.querySelector('[data-specifications]');
  const facts = section.querySelector('[data-spec-facts]');
  const description = section.querySelector('[data-product-description]');
  if (!panel || !facts || !description || panel.dataset.ready) return;
  panel.dataset.ready = 'true';
  const source = [...description.querySelectorAll('p,li')].map(el => el.textContent.replace(/\s+/g, ' ').trim()).filter(text => text.length > 3 && text.length < 220);
  const groups = [
   ['Size', /(?:length|width|height|dimensions|standing size|sitting size)\s*[:\-]?\s*\d/i],
   ['Materials', /(?:polyester|synthetic (?:fiber|fur)|cotton|filling|stuffing)/i],
   ['Care', /(?:spot clean|hand wash|machine wash|air dry|tumble dry|surface wash)/i]
  ];
  groups.forEach(([label, pattern]) => {
   if ([...facts.querySelectorAll('dt')].some(dt => new RegExp(label === 'Size' ? 'Size|Dimensions' : label, 'i').test(dt.textContent))) return;
   const matches = [...new Set(source.filter(text => pattern.test(text)))];
   if (!matches.length) return;
   const row = document.createElement('div'); const term = document.createElement('dt'); const value = document.createElement('dd');
   term.textContent = label === 'Size' ? panel.dataset.sizeLabel : label === 'Materials' ? panel.dataset.materialLabel : panel.dataset.careLabel; value.textContent = matches.slice(0, 3).join(' · '); row.append(term, value); facts.append(row);
  });
  panel.hidden = !facts.children.length;
 });
 const initAvailability = section => {
  const alternatives = section.querySelector('[data-stock-alternatives]');
  if (!alternatives) return;
  const together = section.querySelector('[data-together-content]');
  const grid = alternatives.querySelector('[data-alternatives-grid]');
  let available = true; let loading = false; let loaded = false;
  const render = async variant => {
   available = !!variant?.available;
   document.querySelectorAll('[data-related-products]').forEach(el => { el.hidden = !available; });
   if (together) together.hidden = !available;
   alternatives.hidden = available;
   section.hidden = available ? !together : !grid.children.length;
   if (available || loading || loaded || section.dataset.productGroup === 'type:') return;
   loading = true;
   try {
    let url = new URL(alternatives.dataset.source, location.origin);
    for (let page = 0; page < 8 && grid.children.length < 3; page++) {
     const response = await fetch(url); if (!response.ok) break;
     const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
     const feed = doc.querySelector('[data-alternatives-feed]'); if (!feed) break;
     for (const candidate of feed.querySelectorAll('[data-alternative]')) {
      if (candidate.dataset.productGroup !== section.dataset.productGroup || candidate.dataset.productId === section.dataset.productId) continue;
      if (grid.querySelector(`[data-product-id="${candidate.dataset.productId}"]`)) continue;
      const card = candidate.querySelector('.product-card'); if (!card) continue;
      card.dataset.productId = candidate.dataset.productId; grid.append(card);
      if (grid.children.length === 3) break;
     }
     if (!feed.dataset.next) break;
     url = new URL(feed.dataset.next, location.origin); url.searchParams.set('section_id', 'product-alternatives-feed'); url.searchParams.set('sort_by', 'best-selling');
    }
    loaded = true;
   } catch (_) {} finally { loading = false; if (!available) section.hidden = !grid.children.length; }
  };
  const id = document.querySelector('[data-product-section] [name="id"]')?.value;
  const data = document.querySelector('[data-variant-data]');
  if (data) render(JSON.parse(data.textContent).find(variant => String(variant.id) === id));
  document.addEventListener('bellzi:variant-changed', event => { if (section.isConnected) render(event.detail.variant); });
 };
 const initGallery = scope => scope.querySelectorAll('[data-gallery]').forEach(gallery => {
  if (gallery.dataset.ready) return;
  gallery.dataset.ready = 'true';
  const panels = [...gallery.querySelectorAll('[data-media-id]')];
  const thumbs = [...gallery.querySelectorAll('[data-gallery-thumb]')];
  let index = Math.max(0, panels.findIndex(panel => !panel.hidden));
  const show = next => {
   if (!panels.length) return;
   index = (next + panels.length) % panels.length;
   panels.forEach((panel, i) => {
    panel.hidden = i !== index;
    if (i !== index) {
     panel.querySelectorAll('video').forEach(video => video.pause());
     panel.querySelectorAll('iframe').forEach(frame => { if (frame.src) { frame.dataset.mediaSrc = frame.src; frame.removeAttribute('src'); } });
    } else panel.querySelectorAll('iframe[data-media-src]').forEach(frame => { if (!frame.src) frame.src = frame.dataset.mediaSrc; });
   });
   thumbs.forEach((thumb, i) => thumb.setAttribute('aria-pressed', String(i === index)));
   const counter = gallery.querySelector('[data-gallery-count]');
   if (counter) counter.textContent = `${index + 1} / ${panels.length}`;
  };
  thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => show(i)));
  gallery.querySelector('[data-gallery-prev]')?.addEventListener('click', () => show(index - 1));
  gallery.querySelector('[data-gallery-next]')?.addEventListener('click', () => show(index + 1));
  gallery.addEventListener('bellzi:show-media', event => { const i = panels.findIndex(panel => panel.dataset.mediaId === String(event.detail.id)); if (i >= 0) show(i); });
  gallery.addEventListener('keydown', event => { if (!event.target.closest('.gallery-thumbnails,.gallery-toolbar')) return; if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); show(index + (event.key === 'ArrowRight' ? 1 : -1)); thumbs[index]?.focus(); } });
  let touch;
  gallery.querySelector('.gallery-stage')?.addEventListener('touchstart', event => { touch = event.touches[0]; }, { passive: true });
  gallery.querySelector('.gallery-stage')?.addEventListener('touchend', event => { if (!touch || event.target.closest('video,iframe,model-viewer')) return; const end = event.changedTouches[0]; const dx = end.clientX - touch.clientX; if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(end.clientY - touch.clientY)) show(index + (dx < 0 ? 1 : -1)); touch = null; }, { passive: true });
  const dialog = gallery.querySelector('[data-gallery-dialog]');
  gallery.querySelectorAll('[data-zoom-src]').forEach(button => button.addEventListener('click', () => { const image = dialog.querySelector('img'); image.src = button.dataset.zoomSrc; image.alt = button.dataset.zoomAlt; dialog.style.removeProperty('--zoom-background'); const probe = new Image(); probe.crossOrigin = 'anonymous'; probe.onload = () => { if (image.src !== probe.src) return; try { const canvas = document.createElement('canvas'); canvas.width = canvas.height = 1; const context = canvas.getContext('2d', {willReadFrequently: true}); context.drawImage(probe, 0, 0, 1, 1, 0, 0, 1, 1); const [r,g,b] = context.getImageData(0,0,1,1).data; dialog.style.setProperty('--zoom-background', `rgb(${r}, ${g}, ${b})`); } catch {} }; probe.src = image.src; dialog.showModal(); }));
  dialog.querySelector('[data-gallery-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
  const section = gallery.closest('[data-product-section]');
  const sticky = section.querySelector('[data-sticky-buy]');
  const form = section.querySelector('[data-product-form]');
  if (sticky && form) {
   const observer = new IntersectionObserver(entries => { sticky.hidden = entries[0].boundingClientRect.top >= 0 || entries[0].isIntersecting || !!form.querySelector('[data-add-button]')?.disabled; }, { threshold: 0 });
   observer.observe(form);
   form.addEventListener('change', () => { sticky.hidden = form.getBoundingClientRect().bottom > 0 || !!form.querySelector('[data-add-button]')?.disabled; });
  }
 });
 const initPairings = scope => scope.querySelectorAll('[data-pairings]').forEach(async section => {
  if (section.dataset.loaded) return;
  section.dataset.loaded = 'true';
  try {
   let content;
   for (const intent of ['complementary', 'related']) {
    const url = new URL(section.dataset.pairingsUrl, location.origin); url.searchParams.set('intent', intent);
    const response = await fetch(url); if (!response.ok) continue;
    const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
    content = doc.querySelector('[data-pairings]');
    if (content?.querySelector('[data-pair-companion]')) break;
   }
   if (!content?.querySelector('[data-pair-companion]')) { initAvailability(section); return; }
   section.innerHTML = content.innerHTML; section.hidden = false; initAvailability(section);
   const main = section.querySelector('[data-pair-main]');
   const form = section.querySelector('[data-pairing-form]');
   const submit = section.querySelector('[data-pair-submit]');
   const status = section.querySelector('[data-pair-status]');
   const quantity = document.querySelector('[data-product-section] input[name="quantity"]');
   const productSelect = document.querySelector('[data-product-section] [name="id"]');
   const variantData = document.querySelector('[data-variant-data]');
   const mainLabel = main.dataset.includeLabel;
   const format = cents => new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: section.dataset.currency }).format(cents / 100);
   const update = () => {
    main.dataset.quantity = quantity?.value || '1';
    main.querySelector('[data-pair-main-quantity]').textContent = `× ${main.dataset.quantity}`;
    let total = 0; let companions = 0;
    section.querySelectorAll('.pair-item').forEach(item => { if (item.querySelector('[data-pair-check]').checked && !item.querySelector('[data-pair-check]').disabled) { total += Number(item.dataset.price) * Number(item.dataset.quantity || 1); if (item.hasAttribute('data-pair-companion')) companions++; } });
    section.querySelector('[data-pair-total]').textContent = format(total);
    submit.disabled = !companions || !!form.dataset.busy;
    if (!form.dataset.busy) submit.textContent = companions ? section.dataset.addLabel : section.dataset.chooseLabel;
   };
   const syncVariant = variant => {
    if (!variant) return;
    main.dataset.variant = String(variant.id); main.dataset.price = String(variant.priceCents); main.dataset.available = String(variant.available);
    const checkbox = main.querySelector('[data-pair-check]'); checkbox.disabled = !variant.available; checkbox.checked = variant.available;
    main.querySelector('[data-pair-main-label]').textContent = variant.available ? mainLabel : document.querySelector('[data-availability]').textContent;
    main.querySelector('[data-pair-main-price]').textContent = variant.price;
    main.querySelector('[data-pair-main-option]').textContent = productSelect?.tagName === 'SELECT' ? productSelect.selectedOptions[0].textContent.split(' — ')[0] : '';
    update();
   };
   if (variantData) syncVariant(JSON.parse(variantData.textContent).find(variant => String(variant.id) === productSelect?.value));
   document.addEventListener('bellzi:variant-changed', event => { if (section.isConnected) syncVariant(event.detail.variant); });
   quantity?.addEventListener('input', update); quantity?.addEventListener('change', update);
   section.addEventListener('change', event => {
    if (event.target.matches('[data-pair-variant]')) {
     const option = event.target.selectedOptions[0]; const item = event.target.closest('.pair-item');
     item.dataset.variant = option.value; item.dataset.price = option.dataset.price; item.dataset.quantity = option.dataset.quantity;
     item.querySelector('[data-pair-price]').textContent = option.dataset.money;
     item.querySelector('[data-pair-quantity]').textContent = `× ${option.dataset.quantity}`;
    }
    update();
   });
   const refreshCart = async () => {
    const response = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }); if (!response.ok) return;
    const cart = await response.json(); document.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = cart.item_count; el.closest('a')?.setAttribute('aria-label', `Cart, ${cart.item_count} items`); });
    document.dispatchEvent(new CustomEvent('bellzi:cart-updated', { detail: { cart } }));
   };
   form.addEventListener('submit', async event => {
    event.preventDefault(); if (form.dataset.busy || submit.disabled) return;
    if (main.querySelector('[data-pair-check]').checked && quantity && !quantity.reportValidity()) return;
    const items = [...section.querySelectorAll('.pair-item')].filter(item => item.querySelector('[data-pair-check]').checked && !item.querySelector('[data-pair-check]').disabled).map(item => ({ id: Number(item.dataset.variant), quantity: Number(item.dataset.quantity || 1) }));
    if (!items.length) return;
    form.dataset.busy = 'true'; submit.disabled = true; submit.textContent = section.dataset.adding; status.hidden = true;
    try {
     const response = await fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
     if (!response.ok) throw new Error('Cart add failed');
     status.textContent = section.dataset.added; status.hidden = false;
     section.querySelectorAll('[data-pair-companion] [data-pair-check]').forEach(check => { check.checked = false; });
    } catch (_) { status.textContent = section.dataset.error; status.hidden = false; }
    finally { try { await refreshCart(); } catch (_) {} delete form.dataset.busy; update(); }
   });
   update();
  } catch (_) { section.hidden = true; }
 });
 const init = (scope = document) => { initGallery(scope); initSpecifications(scope); initPairings(scope); };
 init(); document.addEventListener('shopify:section:load', event => init(event.target));
})();
